
export default {
  name: 'FiveStarProductsCategories',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {

    }
  },

  methods: {
    categoryDataInOrder(fromPos,totalItem) {
      function compare(a, b) {
        if (a.DisplayOrder < b.DisplayOrder) {
          return -1;
        }
        if (a.DisplayOrder > b.DisplayOrder) {
          return 1;
        }
        return 0;
      }
      const ordered = JSON.parse(JSON.stringify(this.data?.five_star_categories));
      return ordered?.sort(compare).slice(fromPos,totalItem);
    },

  }
}
